import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { isRequired, niceBytes } from '@elotech/angular-components/utils';

class ControlRequiredPipe {
    transform(control) {
        return isRequired(control);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlRequiredPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ControlRequiredPipe, name: "controlRequired", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlRequiredPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: "controlRequired",
                    pure: false
                }]
        }] });

class RelativeTimeFromNowPipe {
    constructor() {
        this.units = {
            year: 24 * 60 * 60 * 1000 * 365,
            month: 24 * 60 * 60 * 1000 * 365 / 12,
            day: 24 * 60 * 60 * 1000,
            hour: 60 * 60 * 1000,
            minute: 60 * 1000,
            second: 1000
        };
        this.rtf = new Intl.RelativeTimeFormat('pt-br', { numeric: 'auto' });
        this.getRelativeTime = (d1, d2 = new Date()) => {
            let elapsed = d1 - d2;
            for (let u in this.units)
                if (Math.abs(elapsed) > this.units[u] || u == 'second')
                    return this.rtf.format(Math.round(elapsed / this.units[u]), u);
            return '';
        };
    }
    transform(value) {
        return this.getRelativeTime(new Date(value));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RelativeTimeFromNowPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: RelativeTimeFromNowPipe, name: "relativeTimeFromNow" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RelativeTimeFromNowPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'relativeTimeFromNow'
                }]
        }], ctorParameters: () => [] });

class NiceBytesPipe {
    constructor() { }
    transform(value) {
        return niceBytes(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NiceBytesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: NiceBytesPipe, name: "niceBytes" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NiceBytesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'niceBytes'
                }]
        }], ctorParameters: () => [] });

class PipesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PipesModule, declarations: [RelativeTimeFromNowPipe,
            ControlRequiredPipe,
            NiceBytesPipe], imports: [CommonModule], exports: [RelativeTimeFromNowPipe,
            ControlRequiredPipe,
            NiceBytesPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PipesModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        RelativeTimeFromNowPipe,
                        ControlRequiredPipe,
                        NiceBytesPipe
                    ],
                    exports: [
                        RelativeTimeFromNowPipe,
                        ControlRequiredPipe,
                        NiceBytesPipe
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ControlRequiredPipe, NiceBytesPipe, PipesModule, RelativeTimeFromNowPipe };
